export function getAmenities(params: { [key: string]: boolean | null }) {
  const mapParamToAmenitiesQueryValue: { [key: string]: string } = {
    hasKitchenFurniture: 'kitchenFurniture',
    hasWasher: 'washingMachine',
    hasTv: 'tv',
    hasFridge: 'fridge',
    hasConditioner: 'conditioner',
  };

  let startIndex = 0;

  return Object.keys(params)
    .map(key => {
      if (params[key]) {
        const keyValue = `amenities[${startIndex}]=${mapParamToAmenitiesQueryValue[key]}`;
        startIndex += 1;

        return keyValue;
      }

      return null;
    })
    .filter(Boolean)
    .join('&');
}
